<template>
  <div>
    <div id="google_signin" class="mb-4"></div>
    <div id="appleid-signin" data-mode="center-align" data-type="sign-in" data-color="white" data-border="true"
      data-border-radius="4" data-width="178" data-height="38" data-logo-size="small" data-logo-position="5"
      data-label-position="5"></div>
  </div>
</template>

<script>

// import { getApp } from 'firebase/app';
import { GoogleAuthProvider, OAuthProvider, signInWithCredential, signInWithCustomToken, linkWithCredential } from 'firebase/auth';
// import { getFunctions, httpsCallable } from 'firebase/functions';
import Config from "../../../config-app/config";
import { auth, authShared } from '../../../config-firebase/firebase'
import toast from "../../js/toast";
import mixins from '../../js/mixins'
import store from '../../store'

// const functions = getFunctions();

export default {
  name: 'login-sdk-js',
  mixins: [mixins, toast],
  data() {
    return {
    }
  },

  mounted() {
    this.loadGoogleSignIn();
    this.loadAppleSignIn();
  },

  methods: {
    // generateNonce() {
    //   return Math.random().toString(36).substring(2);
    // },
    handleSignInWithCredential(credential) {
      signInWithCredential(authShared, credential)
        // Ho provato a autenticare anche su auth.
        //  Ma funziona solo su Google e non su Apple.
        // Vedi le prove fatte per Apple in handleAppleIDSignInOnSuccess
        // Per ora standalone userà solo 1 DB :( 
        // .then(() => {
        //   console.log('credential', credential)
        //   return signInWithCredential(auth, credential)
        // })
        .then((result) => {
          let user = result.user;
          this.successToast('Ciao', user.displayName);
          let redirect = this.$route.query.redirect || '/';
          this.$router.push({ path: redirect });
        })
        .catch((error) => {
          this.errorToast("Login Error", error.message);
          console.log("Login Error: ", error);
        });
    },

    // apple
    loadAppleSignIn() {
      const script = document.createElement("script");
      script.src = Config.APPLE_SIGNIN_JS_SDK;
      script.async = true;
      script.defer = true;
      script.onload = () => this.initializeAppleSignIn();
      document.head.appendChild(script);
    },
    initializeAppleSignIn() {
      window.AppleID.auth.init({
        clientId: Config.APPLE_SIGNIN_CLIENT_ID,
        scope: 'name email',
        // https://developer.apple.com/forums/thread/130666
        // localhost solution etc/host ???  https://developer.apple.com/forums/thread/128788 
        redirectURI: Config.APPLE_SIGNIN_REDIRECT_URI,
        responseMode: 'web_message',
        usePopup: true
      })
      document.addEventListener('AppleIDSignInOnSuccess', this.handleAppleIDSignInOnSuccess);
      document.addEventListener('AppleIDSignInOnFailure', this.handleAppleIDSignInOnFailure);
    },

    // importante: questo evento viene non viene richiamato su localhost!
    // puoi testarlo solo sull'host vero e proprio
    handleAppleIDSignInOnSuccess(event) {
      const id_token = event.detail.authorization.id_token;
      const provider = new OAuthProvider('apple.com');
      const credential = provider.credential({ idToken: id_token });
      this.handleSignInWithCredential(credential);

      // console.log('credential', credential)
      // signInWithCredential(authShared, credential)
      //   .then((result) => {
      //     console.log('result', result)
          

      //     // console.log('id_token', id_token)
      //     // return signInWithCustomToken(auth, id_token)

      //     // console.log('auth', auth)
      //     // console.log('auth.currentUser', auth.currentUser)
      //     // return linkWithCredential(auth.currentUser, credential)


      //     // return user.getIdToken()

      //     // let user = result.user;
      //     // const generateCustomToken = httpsCallable(functions, 'generateCustomTokenFromUid');
      //     // return generateCustomToken({ uid: user.uid });

      //   })
      //   .then((result) => {
      //     console.log('result', result)
      //     const token = result.data.token;
      //     console.log('token', token)
      //     return signInWithCustomToken(auth, token)
      //   })
      //   .then((result) => {
      //     console.log('result', result)
      //     let user = result.user;
      //     this.successToast('Ciao', user.displayName);
      //     let redirect = this.$route.query.redirect || '/';
      //     this.$router.push({ path: redirect });
      //   })
      //   .catch((error) => {
      //     this.errorToast("Login Error", error.message);
      //     console.log("Login Error: ", error);
      //   });
    },

    handleAppleIDSignInOnFailure() {

    },

    // google
    loadGoogleSignIn() {
      const script = document.createElement("script");
      script.src = Config.GOOGLE_SIGNIN_JS_SDK;
      script.async = true;
      script.defer = true;
      script.onload = () => this.initializeGoogleSignIn();
      document.head.appendChild(script);
    },
    initializeGoogleSignIn() {
      window.google.accounts.id.initialize({
        client_id: Config.GOOGLE_SIGNIN_CLIENT_ID,
        callback: this.onGoogleSignInCallback,
        auto_select: false,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("google_signin"),
        { theme: "outline", size: "large" });
    },
    onGoogleSignInCallback(response) {
      // Build Firebase credential with the Google ID token.
      const idToken = response.credential;
      const credential = GoogleAuthProvider.credential(idToken);
      this.handleSignInWithCredential(credential);
    },
  },

  created() {
    console.log('Login created.');
  },

  destroyed() {
    console.log('Login destroyed.');
    document.removeEventListener('AppleIDSignInOnSuccess', this.handleAppleIDSignInOnSuccess);
    document.removeEventListener('AppleIDSignInOnFailure', this.handleAppleIDSignInOnFailure);
  }
}
</script>

